import { useEffect, useRef } from 'react'
import { useRecentlyVisited } from './useRecentlyVisited'
import { EntityType } from '../types'

interface PageVisitInfo {
    type: EntityType
    id: string | undefined
    name: string | undefined
    subtitle?: string
    path?: string
}

export function useRegisterPageVisit(info: PageVisitInfo) {
    const { addVisit } = useRecentlyVisited()
    const hasRegistered = useRef(false)

    useEffect(() => {
        if (!info.id || !info.name) return
        if (hasRegistered.current) return

        hasRegistered.current = true
        addVisit(info.type, info.id, info.name, info.subtitle, info.path)
    }, [info.id, info.name, info.type, info.subtitle, info.path, addVisit])

    useEffect(() => {
        hasRegistered.current = false
    }, [info.id])
}
